import { Box, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormSectionsQuery } from '../../../../hooks/queries/qhse/forms/useFormSectionQuery';
import { FormSection } from '../../../../services/apiSLTP/qhse/forms/formSections';
import Icon from '../../../ui/Icon';
import ModalBody, { ModalProps } from '../../ModalBody';

interface MoveSectionsModalProps extends ModalProps {
    onMoveSection: (sectionId: string, order: number) => void;
    sectionId: string;
    templateId: string;
}

const MoveSectionsModal: React.FC<MoveSectionsModalProps> = ({ onMoveSection, handleClose, open, sectionId, templateId }) => {
    const { t } = useTranslation();
    const [localSections, setLocalSections] = useState<FormSection[]>([]);

    const { data: dataSections } = useFormSectionsQuery({ templateId });

    useEffect(() => {
        if (dataSections) setLocalSections(dataSections.map((s) => ({ ...s })));
    }, [dataSections]);

    const moveUp = (index: number) => {
        if (index === 0) return;
        const newSections = [...localSections];
        [newSections[index - 1], newSections[index]] = [newSections[index], newSections[index - 1]];
        setLocalSections(newSections);
    };

    const moveDown = (index: number) => {
        if (index === localSections.length - 1) return;
        const newSections = [...localSections];
        [newSections[index + 1], newSections[index]] = [newSections[index], newSections[index + 1]];
        setLocalSections(newSections);
    };

    const handleOk = () => {
        onMoveSection(
            sectionId,
            localSections.findIndex((s) => s._id === sectionId)
        );
        handleClose();
    };

    return (
        <ModalBody title={t('sections')} subtitle={t('move')} open={open} handleClose={handleClose} onSubmit={handleOk}>
            <Box display="flex" flexDirection="column" gap={1} py={1}>
                {localSections.map((section, index) => (
                    <Box
                        key={section._id}
                        display="flex"
                        flexDirection={'row'}
                        alignItems="center"
                        justifyContent="space-between"
                        p={1}
                        bgcolor={section._id === sectionId ? 'action.selected' : 'background.paper'}
                        borderRadius={1}
                    >
                        <Typography>{`Section ${index + 1} : ${section.title || t('noTitle')}`}</Typography>
                        {section._id === sectionId && (
                            <Box>
                                <IconButton size="small" disabled={index === 0} onClick={() => moveUp(index)}>
                                    <Icon name="arrowUpward" />
                                </IconButton>
                                <IconButton size="small" disabled={index === localSections.length - 1} onClick={() => moveDown(index)}>
                                    <Icon name="arrowDownward" />
                                </IconButton>
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
        </ModalBody>
    );
};

export default MoveSectionsModal;
